const GENITIVE_AFTER_FULL_HUNDREDS = [100, 200, 300, 400, 500, 600, 700, 800, 900]

function scaled(singular, plural, genitivePlural) {
  return {
    singular,
    plural,
    useAlternativeUnit: GENITIVE_AFTER_FULL_HUNDREDS,
    alternativeUnit: genitivePlural,
    useSingularEnding: true,
    avoidSingularWhenMod100: 11,
  }
}

export default {
  useLongScale: false,
  baseSeparator: " ",
  unitSeparator: "",
  base: {
    "0": "nulle",
    "1": "viens",
    "2": "divi",
    "3": "trīs",
    "4": "četri",
    "5": "pieci",
    "6": "seši",
    "7": "septiņi",
    "8": "astoņi",
    "9": "deviņi",
    "10": "desmit",
    "11": "vienpadsmit",
    "12": "divpadsmit",
    "13": "trīspadsmit",
    "14": "četrpadsmit",
    "15": "piecpadsmit",
    "16": "sešpadsmit",
    "17": "septiņpadsmit",
    "18": "astoņpadsmit",
    "19": "deviņpadsmit",
    "20": "divdesmit",
    "30": "trīsdesmit",
    "40": "četrdesmit",
    "50": "piecdesmit",
    "60": "sešdesmit",
    "70": "septiņdesmit",
    "80": "astoņdesmit",
    "90": "deviņdesmit",
    "100": "viens simts",
    "200": "divi simti",
    "300": "trīs simti",
    "400": "četri simti",
    "500": "pieci simti",
    "600": "seši simti",
    "700": "septiņi simti",
    "800": "astoņi simti",
    "900": "deviņi simti",
  },
  units: [
    {
      useBaseInstead: true,
      useBaseException: [],
    },
    scaled("tūkstotis", "tūkstoši", "tūkstošu"),
    scaled("miljons", "miljoni", "miljonu"),
    scaled("miljards", "miljardi", "miljardu"),
    scaled("triljons", "triljoni", "triljonu"),
    scaled("kvadriljons", "kvadriljoni", "kvadriljonu"),
    scaled("kvintiljons", "kvintiljoni", "kvintiljonu"),
    scaled("sekstiljons", "sekstiljoni", "sekstiljonu"),
    scaled("septiljons", "septiljoni", "septiljonu"),
    scaled("oktiljons", "oktiljoni", "oktiljonu"),
    scaled("noniljons", "noniljoni", "noniljonu"),
    scaled("deciljons", "deciljoni", "deciljonu"),
    scaled("undeciljons", "undeciljoni", "undeciljonu"),
    scaled("duodeciljons", "duodeciljoni", "duodeciljonu"),
    scaled("tredeciljons", "tredeciljoni", "tredeciljonu"),
    scaled("kvatuordeciljons", "kvatuordeciljoni", "kvatuordeciljonu"),
    scaled("kvintdeciljons", "kvintdeciljoni", "kvintdeciljonu"),
  ],
  unitExceptions: [],
  currencies: {
    EUR: {
      singular: "eiro",
      plural: "eiro",
      cents: "centi",
    },
  },
}
